import { FUTURE_TOKENS } from '../constants/futureTokens.js';

var DROP_SHADOWS = ["0px 8px 8px ".concat(FUTURE_TOKENS.DROP_SHADOW_COLORS.PARAMETERS_0_8_8), "0px 8px 16px ".concat(FUTURE_TOKENS.DROP_SHADOW_COLORS.PARAMETERS_0_8_16), "0px 16px 24px ".concat(FUTURE_TOKENS.DROP_SHADOW_COLORS.PARAMETERS_0_16_24), "0px 24px 32px ".concat(FUTURE_TOKENS.DROP_SHADOW_COLORS.PARAMETERS_0_24_32)];
function getDropShadowByElevation(level) {
  return level ? DROP_SHADOWS[level - 1] : void 0;
}

export { getDropShadowByElevation };
